import api from "./api";

export const naira = (n) => `₦${Number(n || 0).toLocaleString()}`;
export const ORDER_LABEL = { pending_confirmation: "Pending confirmation", paid: "Paid — confirmed", shipped: "Shipped", cancelled: "Cancelled" };
export const ORDER_TONE = { pending_confirmation: "bg-amber-100 text-amber-800", paid: "bg-green-100 text-green-800", shipped: "bg-blue-100 text-blue-800", cancelled: "bg-black/10 text-[#0a0d12]/60" };

const CHUNK = 900 * 1024;
// Chunked private PDF upload for a book (≤25 MB). Never served publicly.
export async function uploadBookPdf(bookId, file, onProgress) {
  if (file.size > 25 * 1024 * 1024) throw new Error("PDF exceeds the 25 MB limit");
  const dataUrl = await new Promise((res, rej) => { const r = new FileReader(); r.onload = () => res(r.result); r.onerror = rej; r.readAsDataURL(file); });
  const b64 = dataUrl.split(",")[1];
  const total = Math.ceil(b64.length / CHUNK);
  const upload_id = crypto.randomUUID();
  let result = null;
  for (let index = 0; index < total; index++) {
    const { data } = await api.post(`/admin/store/books/${bookId}/pdf/chunk`, { upload_id, index, total, data: b64.slice(index * CHUNK, (index + 1) * CHUNK), name: file.name });
    onProgress?.(Math.round(((index + 1) / total) * 100));
    if (data.complete) result = data;
  }
  return result;
}
